export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 170,
    slots: {
      default: 'opt'
    }
  },

  {
    field: 'userName',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    title: '账号名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'userMobileNo',
    minWidth: 150,
    align: 'left',
    title: '手机号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'userEmail',
    minWidth: 200,
    align: 'left',
    title: '邮箱',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'userWechat',
    minWidth: 200,
    align: 'left',
    title: '微信号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'orgName',
    minWidth: 250,
    align: 'left',
    title: '所在机构',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'userJob',
    minWidth: 150,
    align: 'left',
    title: '职务',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'userStatus',
    width: 80,
    align: 'center',
    title: '状态',
    slots: { default: 'status' }
  },
  {
    headerAlign: 'center',
    field: 'createByName',
    title: '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'createTime',
    title: '创建时间',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'modifyByName',
    title: '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'modifyTime',
    title: '修改时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  }
]
